import { PaymentGateways } from '../enums';
import { couponApplyBuilder } from '../utils';
import { buildCloudPayQuery } from '../utils/query';
import { merge } from 'lodash';
/**
 * @description Veirfy discount coupons code
 *
 * @param {Object} [Request options]
 * @returns {QueryConfig}
 */
export const ApplyCouponCodeRequest = buildCloudPayQuery(
  ({
    code,
    client,
    shoppingCart,
    token,
    exchangeRate,
    captchaToken,
    products: productCatalog,
    promoSlug,
  }) => ({
    force: true,
    url: '/admin/coupon/verify',
    options: {
      method: 'POST',
      authorization: 'Bearer ' + token
    },
    body: {
      code,
      client,
      captchaToken,
      productsIds: shoppingCart?.productsToBuy?.map(product => product.productID),
      skipProductCouponMatch: true,
      ...(promoSlug && { promoSlug }),
    },
    transform: (response) => {
      const catalog = productCatalog || [];
      const couponProductIds = response.coupon?.products || [];
      const currentProductsToBuy = shoppingCart?.productsToBuy?.length
        ? [...shoppingCart.productsToBuy]
        : [];
      let productsToBuy = [...currentProductsToBuy];

      const cartIds = productsToBuy.map((p) => p.productID);
      const intersects =
        couponProductIds.length === 0 ||
        couponProductIds.some((id) => cartIds.includes(id));

      const rejectCouponApply = () => ({
        shoppingCart: { ...(shoppingCart || {}), productsToBuy: currentProductsToBuy },
        couponApplyRejected: { code: 'CPAY-061' },
      });

      if (couponProductIds.length && !intersects && couponProductIds.length !== 1) {
        return rejectCouponApply();
      }

      if (couponProductIds.length === 1 && (!intersects || !productsToBuy.length)) {
        if (!catalog.length) {
          return rejectCouponApply();
        }
        const couponProducts = catalog.filter((p) => couponProductIds.includes(p.productID));
        if (!couponProducts.length) {
          return rejectCouponApply();
        }
        productsToBuy = couponProducts;
      }

      const allowAddMissingProduct = couponProductIds.length === 1 && !intersects;
      (response.products || []).forEach((productCoupon) => {
        let indexItem = productsToBuy.findIndex((item) => item.productID === productCoupon.productId);
        if (indexItem === -1 && catalog.length && allowAddMissingProduct) {
          const fullProduct = catalog.find((p) => p.productID === productCoupon.productId);
          if (fullProduct) {
            productsToBuy.push({ ...fullProduct });
            indexItem = productsToBuy.length - 1;
          }
        }
        if (indexItem < 0) return;
        const itemProduct = productsToBuy[indexItem];
        const discountPriceToShow = itemProduct.originalCurrency === 'USD'
          ? productCoupon.newPrice * (exchangeRate?.rate || 1)
          : (productCoupon.newPrice / (exchangeRate?.rate || 1));
        productsToBuy[indexItem] = { ...productsToBuy[indexItem], discountPriceToShow };
      });
      const couponApply = couponApplyBuilder(response.coupon);
      return { shoppingCart: { ...(shoppingCart || {}), productsToBuy }, couponApply };
    },
    update: {
      shoppingCart: merge,
      couponApply: merge
    }
  }),
);

export const VerifyFreePassRequest = buildCloudPayQuery(
  ({ code, client, token, shoppingCart, exchangeRate, products, captchaToken, skipProductCouponMatch }) => ({
    force: true,
    url: '/admin/freepass/verify',
    options: {
      method: 'POST',
      authorization: 'Bearer ' + token
    },
    body: {
      code,
      client,
      captchaToken,
      ...(skipProductCouponMatch === true && { skipProductCouponMatch: true }),
      ...(shoppingCart?.productsToBuy?.length && {
        productsIds: shoppingCart.productsToBuy.map((product) => product.productID),
      }),
    },
    transform: (response) => {
      if (response?.coupon?.couponType !== PaymentGateways.freepass) {
        let productsToBuy;
        const useCouponProductsOnly =
          skipProductCouponMatch === true || !shoppingCart?.productsToBuy;
        if (useCouponProductsOnly) {
          productsToBuy = products?.filter(prod => response.coupon.products.includes(prod.productID));
        } else {
          productsToBuy = shoppingCart?.productsToBuy;
        }
        response.products.forEach(productCoupon => {
          const itemProduct = productsToBuy.find(product => product.productID === productCoupon.productId);
          const discountPriceToShow = itemProduct.originalCurrency === 'USD'
            ? productCoupon.newPrice * (exchangeRate?.rate || 1)
            : (productCoupon.newPrice / (exchangeRate?.rate || 1));
          // update product only in shoppingCart
          const indexItem = productsToBuy.findIndex(item => item.productID === productCoupon.productId);
          productsToBuy[indexItem] = { ...productsToBuy[indexItem], discountPriceToShow }
        });
        const couponApply = couponApplyBuilder(response.coupon);
        return { shoppingCart: { ...(shoppingCart || {}), productsToBuy }, couponApply };
      }
      return response;
    },
    update: {
      shoppingCart: merge,
      couponApply: merge
    }
  }),
);
